import { useState } from 'react';
import ExoForm from '../ExoForm';
import * as Yup from 'yup';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../../api/api';
import { useTranslation } from 'react-i18next';

export const NewMatchingPropertyNumber = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onFeedback,
  salesLevelId,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: t('Label'),
      type: 'text',
      key: 'label',
      colspan: 2,
    },
    {
      label: t('Unit'),
      type: 'text',
      key: 'unit',
      colspan: 2,
    },
    {
      label: t('Thousand Separator'),
      type: 'checkbox',
      key: 'thousandSeparator',
      colspan: 1,
    },
    {
      label: t('Decimal Places'),
      type: 'number',
      key: 'decimalPlaces',
      decimalPlaces: 0,
      colspan: 1,
    },
    {
      label: t('Comparative behavior'),
      type: 'customSelect',
      key: 'comparativeBehavior',
      noUnselect: true,
      options: [
        {
          label: t('the smaller the better'),
          value: 'min',
        },
        {
          label: t('the bigger the better'),
          value: 'max',
        },
        {
          label: t('not comparable'),
          value: 'diff',
        },
      ],
      colspan: 2,
    },
    {
      label: t('Save in library'),
      key: 'isGlobal',
      type: 'checkbox',
      colspan: 2,
    },
    {
      label: t('Is an exclusion criterion'),
      key: 'isStrict',
      type: 'checkbox',
      colspan: 2,
    },
  ];

  const validationSchema = Yup.object().shape({
    label: Yup.string().required(t('Is required')),
  });

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);
    DBRequest({
      config,
      path: isUpdate
        ? `sales-object-properties/${data.id}`
        : `sales-object-properties`,
      method: isUpdate
        ? API_PATCH(data)
        : API_POST({ ...data, salesLevelId, type: 'number' }),
      onResponse: isUpdate ? onUpdate : onCreate,
      onLoading: setIsLoading,
    });
  }

  return (
    <ExoForm
      fields={fields}
      startDataCollection={
        startData || {
          comparativeBehavior: 'diff',
          thousandSeparator: true,
          decimalPlaces: 2,
        }
      }
      onSubmit={handleSubmit}
      onCancel={onClose}
      isLoading={isLoading}
      validationSchema={validationSchema}
      noDifferences
      className="grid grid-cols-2 gap-4 pt-2"
    />
  );
};
